import {
	createSlice,
} from '@reduxjs/toolkit';
import {
	CollectionJson,
} from '@@types/Collection';
import {
	OfferEntryJson,
} from '@layouts/Pages/PageOfferEntry';

export interface OffersEntryJsonStore {
	instance: CollectionJson<OfferEntryJson>;
}

// Define the initial state using that type
const initialState: OffersEntryJsonStore = {
	// État initial de notre reducer qui stock les formulaires
	instance: {
		collection: [],
		count: 0,
	},
};

export const offersEntrySlice = createSlice({
	initialState,
	name: 'offers_entry',
	reducers: {
		clearOffersEntryJsonStore: (state) => {
			state.instance = {
				collection: [],
				count: 0,
			};
		},
		deleteOfferEntryJsonStore: (state, action) => {
			const findOfferEntry = state.instance.collection.filter((offerEntry: OfferEntryJson) => {
				if (offerEntry.id && action.payload.id && offerEntry.id === action.payload.id) {
					return offerEntry;
				}
			});

			if (findOfferEntry.length) {
				state.instance.collection = state.instance.collection.filter((offerEntry: OfferEntryJson) => offerEntry.id !== action.payload.id);
			}
		},
		setOffersEntryJsonStore: (state, action) => {
			const findOfferEntry = state.instance.collection.filter((offerEntry: OfferEntryJson) => {
				if (offerEntry.id && action.payload.id && offerEntry.id === action.payload.id) {
					return offerEntry;
				}
			});

			if (findOfferEntry.length) {
				const offers = state.instance.collection.map((offerEntry: OfferEntryJson) => {
					if (offerEntry.id && action.payload.id && offerEntry.id === action.payload.id) {
						return action.payload as OfferEntryJson;
					} else {
						return offerEntry;
					}
				});
				state.instance.collection = offers;
			} else {
				state.instance.count = state.instance.count + 1;
				state.instance.collection = [
					action.payload,
					...state.instance.collection,
				];
			}
		},
	},
});

export const {
	clearOffersEntryJsonStore,
	deleteOfferEntryJsonStore,
	setOffersEntryJsonStore,
} = offersEntrySlice.actions;

export const offersEntryReducer = offersEntrySlice.reducer;
